module.exports = __webpack_public_path__ + "static/media/Calender.6383c3ba.svg";